var exports = {
  "k": "xcc377c0b--d0419e--container",
};

module.exports = exports;
